import React from 'react';
import styled, { css, keyframes } from 'styled-components';

interface Props {
  color: string;
  pulse?: boolean;
  className?: string;
  style?: React.CSSProperties;
}

export const StatusCircle: React.FC<Props> = props => {
  const { color, pulse, className, style } = props;

  return (
    <StyledStatusCircle
      color={color}
      pulse={pulse}
      className={className ?? ''}
      style={style}
    />
  );
};

const pulse = (color: string) => keyframes`
  0% {
    box-shadow: 0 0 0 0 rgba(${color}, 0.4);
  }
  70% {
    box-shadow: 0 0 0 12px rgba(${color}, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(${color}, 0);
  }
`;

export const StyledStatusCircle = styled.span<{
  color: string;
  pulse?: boolean;
}>`
  display: inline-block;
  min-height: 8px;
  min-width: 8px;
  border-radius: 50%;
  margin: 0 8px;
  background: rgb(${props => props.color});
  box-shadow: 0 0 0 6px rgba(${props => props.color}, 0.24);
  animation: ${props =>
    props.pulse
      ? css`
          ${pulse(props.color)} 2s infinite
        `
      : 'none'};
`;
